/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Api } from '../providers/api/api';

@Injectable()
export class SettingsService extends Api {

  private url: string = this.getBaseUrl();

  public getSettings(): Observable<any> {
    return this.http.get(this.url + '/settings/get-settings');
  }

  public setSettings(params): Observable<any> {
    return this.http.post(this.url + '/settings/create-settings', params);
  }
}
